<script>
import { counterMixin } from '@mixins/counter-mixin';
import { mask } from 'vue-the-mask';

export default {
  components: {},
  directives: { mask },
  props: {
    number: {
      type: [Number, String],
      required: true,
      default: null,
    },
    mode: {
      type: String,
      required: false,
      default: null,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
  },
  mixins: [counterMixin],
  data() {
    return {
      editing: false,
      initialNumber: 0,
    };
  },
  computed: {
    isTime() {
      return this.type && this.type === 'time';
    },
  },
  mounted() {
    this.initialNumber = this.number;
  },
  methods: {
    toggleEdit() {
      this.editing = true;
      setTimeout(() => {
        this.$refs.inlineEditInput.focus();
        this.$refs.inlineEditInput.select();
      });
    },
    validate(evt) {
      const val = evt.target.value;
      if (this.isTime) {
        this.editing = false;
        this.$emit('update-editable-num', this.$_covertToSeconds(val));
      } else {
        if (val > 0 && val !== '') {
          this.editing = false;
          this.$emit('update-editable-num', parseInt(val));
        } else {
          this.editing = false;
          this.$emit('update-editable-num', 0);
        }
      }
    },
  },
};
</script>

<template>
  <span :class="{ showing: editing }" @focus="toggleEdit">
    <span
      class="inline-text"
      v-show="!editing && mode !== 'edit'"
      @click="toggleEdit"
    >
      {{ number }}
    </span>
    <input
      v-if="isTime"
      v-show="editing || mode === 'edit'"
      :class="['input-inline-edit', { lightTxt: color }]"
      type="tel"
      v-mask="[`:##`, `#:##`, `##:##`, `###:##`]"
      ref="inlineEditInput"
      tabindex="0"
      :value="number"
      @keydown.enter="validate"
      @blur="validate"
    />

    <input
      v-else
      v-show="editing || mode === 'edit'"
      :class="['input-inline-edit', { lightTxt: color }]"
      type="number"
      ref="inlineEditInput"
      tabindex="0"
      :value="number"
      @keydown.enter="validate"
      @blur="validate"
    />
  </span>
</template>

<style lang="scss" scoped>
@import '@design';

.input-inline-edit {
  background: $color-off-white;
  border: 0;
  border-bottom: 1px solid $color-border-light-gray;
  color: $color-text;
  font-weight: 600;
  padding: 0;
  text-align: center;
  transition: border-bottom $duration-animation-base ease-in-out;
  width: 100%;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
  }

  &.lightTxt {
    color: $color-off-white;
  }
}
</style>
